import React from 'react'
import {
    Col,
    Modal,
    ModalBody,
    ModalHeader,
    ModalTitle,
    Row
} from 'react-bootstrap'
import InputControl from '../InputControl'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import Swal from 'sweetalert2'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import requestApi from '../../utils/request'

const FeesModal = ({ editbtn, seteditbtn, getFees, setFees, sellerId }) => {
    const queryClient = useQueryClient()

    const feesupdateSchema = yup.object({
        servicefees: yup.string().required('Please enter service fee')
    })

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        defaultValues: { servicefees: getFees },
        resolver: yupResolver(feesupdateSchema)
    })

    function adminEditProfile(servicefees) {
        return requestApi.post(`/vendor/edit`, {
            servicefee: servicefees,
            sellerId: sellerId
        })
    }
    const mutation = useMutation(adminEditProfile, {
        onSuccess: (res) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: res?.data?.meta?.message
            })
            queryClient.invalidateQueries('admin-profile')
            seteditbtn(false)
        },
        onError: (err) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: err?.message
            })
        }
    })

    const handleFees = (data) => {
        const { servicefees } = data
        mutation.mutate(servicefees)
    }

    return (
        <Modal
            show={editbtn}
            onHide={() => seteditbtn(false)}
            style={{ backdropFilter: 'blur(2px)' }}
        >
            <ModalHeader closeButton>
            </ModalHeader>
            <ModalBody>
                {/* <form onSubmit={handleSubmit(handleFees)}>
                    <Row>
                        <Col xxl="12" lg="12" md="12">
                            <InputControl
                                type="number"
                                label="Services Fee (%)"
                                name="servicefees"
                                register={register}
                                error={errors.servicefees?.message}
                            />
                        </Col>
                        <Col lg="12">
                            <button className="solid-red-btn" type="submit">
                                Save
                            </button>
                        </Col>
                    </Row>
                </form> */}

                <div
                    class=" admin-card"
                    id="categorymodal001"
                    name="servicefeesmodal"
                    aria-label="modal_cateogry"
                >
                    <div class="head">
                        <h2>Edit Service Fees</h2>
                    </div>
                    <div class="admin-form-body">
                        <form  onSubmit={handleSubmit(handleFees)}>

                                <div class="form-group">
                                    <InputControl
                                        type="number"
                                        label="Services Fee (%)"
                                        name="servicefees"
                                        register={register}
                                        error={errors.servicefees?.message}
                                    />
                                </div>
                                <button type="submit" class="solid-red-btn">
                                    Save
                                </button>

                        </form>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    )
}

export default FeesModal
